module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"flowPlatform":"Flow Platform","flowService":"Marketplace","iotHardware":"IOT Hardware","party":"3rd Party Integration","connectSubtitle":"Connect IOT and Apps to your stores","flowgo":"Flow Go"}}')
  delete Component.options._Ctor
}
